import { useMemo } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { getVoidAdminGuidance } from "../../../../data/flight/order/getVoidAdminGuidance";

const TONE_CLASS = {
  action: "bg-[#DBEAFE] border-primary1",
  wait: "bg-amber-50 border-amber-300",
  success: "bg-green-50 border-green-300",
  danger: "bg-red-50 border-red-300",
  info: "bg-gray-50 border-gray-200",
};

const TITLE_CLASS = {
  action: "text-gray-900",
  wait: "text-amber-900",
  success: "text-green-800",
  danger: "text-red-700",
  info: "text-gray-900",
};

export default function VoidNextStepCard({ data, loading = {}, onAction }) {
  const guidance = useMemo(() => getVoidAdminGuidance(data), [data]);
  const actionBusy = Object.values(loading || {}).some(Boolean);
  const steps = guidance.steps || [];

  return (
    <div
      className={`w-full rounded-xl mt-4 flex flex-col gap-3 px-4 py-4 border ${
        TONE_CLASS[guidance.tone] || TONE_CLASS.info
      }`}
    >
      <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <FaExclamationTriangle
            className={`mt-1 flex-shrink-0 ${
              guidance.tone === "danger"
                ? "text-red-500"
                : guidance.tone === "success"
                  ? "text-green-600"
                  : "text-yellow-500"
            }`}
          />
          <div className="text-sm text-gray-800 flex flex-col gap-1">
            <span
              className={`font-semibold text-base ${
                TITLE_CLASS[guidance.tone] || TITLE_CLASS.info
              }`}
            >
              {guidance.title}
            </span>
            <span>{guidance.description}</span>
            {steps.length ? (
              <div className="mt-2">
                <div className="font-semibold text-gray-900">Do this</div>
                <ol className="mt-1 list-decimal pl-5 space-y-1">
                  {steps.map((step) => (
                    <li key={step}>{step}</li>
                  ))}
                </ol>
              </div>
            ) : null}
            {data?.reason ? (
              <span className="text-xs text-gray-600">
                Request reason: {data.reason}
              </span>
            ) : null}
            {guidance.stage === "send_failed" &&
            data?.supplierResponse?.data?.error ? (
              <span className="text-xs text-gray-600">
                Supplier said: {data.supplierResponse.data.error}
              </span>
            ) : null}
          </div>
        </div>
      </div>

      {guidance.primary?.length || guidance.secondary?.length ? (
        <div className="flex flex-wrap items-center gap-2 pl-7">
          {guidance.primary.map((action) => (
            <button
              key={action.key}
              type="button"
              disabled={actionBusy}
              onClick={() => onAction?.(action.key)}
              className="h-10 px-4 rounded-md bg-primary1 text-white text-sm font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading?.[action.key] ? (
                <span className="buttonLoader inline-block" />
              ) : (
                action.label
              )}
            </button>
          ))}
          {guidance.secondary.map((action) => (
            <button
              key={action.key}
              type="button"
              disabled={actionBusy}
              onClick={() => onAction?.(action.key)}
              className="h-10 px-4 rounded-md border border-gray-400 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60"
            >
              {loading?.[action.key] ? (
                <span className="buttonLoader inline-block" />
              ) : (
                action.label
              )}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
